// React Dependencies
import React from 'react';

// External Dependencies
import { Button, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

// Internal Dependencies
import FloatingColourPicker from '../../../FloatingColourPicker';
import { Colours } from '../../../../common/constants';

const ColorPickerInput = (props) => (
  <>
    <Typography style={{ fontSize: 13 }} className="mb-1">
      {props.label}
    </Typography>
    <FloatingColourPicker
      open={props.isOpen}
      placement="bottom"
      colour={props.colour}
      onChange={props.onChange}
      onClose={async (e) => {
        e.stopPropagation();
        props.onClose();
      }}
    >
      <Button
        disabled={props.isDisabled}
        onClick={(e) => {
          e.stopPropagation();
          props.onButtonClick();
        }}
        style={{
          height:          '40px',
          width:           '180px',
          border:          `1px solid ${Colours.Gray3}`,
          backgroundColor: props.colour,
          borderRadius:    0,
          cursor:          'pointer',
        }}
      />
    </FloatingColourPicker>
  </>
);

ColorPickerInput.propTypes = {
  label:         PropTypes.string.isRequired,
  isOpen:        PropTypes.bool.isRequired,
  isDisabled:    PropTypes.bool,
  colour:        PropTypes.string.isRequired,
  onChange:      PropTypes.func,
  onClose:       PropTypes.func,
  onButtonClick: PropTypes.func,
};

ColorPickerInput.defaultProps = {
  isDisabled:    false,
  onChange:      () => {},
  onClose:       () => {},
  onButtonClick: () => {},
};

export default ColorPickerInput;
